module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', {
    staticClass: "header-h1"
  }, [_vm._v(_vm._s(_vm.locale.t("label_view_terms_for_day")) + ": " + _vm._s(_vm.currentDate))]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "foo width-half"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo section-bottom-sm"
  }, [(_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.activateDeactivate(true)
      }
    }
  }, [_c('i', {
    staticClass: "ti-check"
  }), _vm._v(" " + _vm._s(_vm.filteredSlots.length === _vm.slots.length ? _vm.locale.t("label_activate_all") : _vm.locale.t("label_activate_all_filtered")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.activateDeactivate(false)
      }
    }
  }, [_c('i', {
    staticClass: "ti-close"
  }), _vm._v(" " + _vm._s(_vm.filteredSlots.length === _vm.slots.length ? _vm.locale.t("label_deactivate_all") : _vm.locale.t("label_deactivate_all_filtered")) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_day")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_training_type")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_max_people")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_time")))]), _vm._v(" "), (_vm.isVisibleAddUserToTerm) ? _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_reserve_training")))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_edit")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_delete")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_delete_and_cancel_all_users")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_deactivate")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredSlots), function(slot, index) {
    return _c('tr', {
      style: (_vm.getRowStyle(slot))
    }, [_c('td', {
      style: (_vm.getRowStyle(slot)),
      attrs: {
        "data-title": _vm.locale.t('label_day')
      }
    }, [_vm._v(_vm._s(slot.date))]), _vm._v(" "), _c('td', {
      style: (_vm.getRowStyle(slot)),
      attrs: {
        "data-title": _vm.locale.t('label_training_type')
      }
    }, [_vm._v(_vm._s(slot.trainingType))]), _vm._v(" "), _c('td', {
      style: (_vm.getRowStyle(slot)),
      attrs: {
        "data-title": _vm.locale.t('label_max_people')
      }
    }, [_vm._v(_vm._s(slot.maxTrainings))]), _vm._v(" "), _c('td', {
      style: (_vm.getRowStyle(slot)),
      attrs: {
        "data-title": _vm.locale.t('label_time')
      },
      on: {
        "mouseover": function($event) {
          _vm.upHere = true;
          _vm.upIndex = index
        },
        "mouseleave": function($event) {
          _vm.upHere = false;
          _vm.upIndex = -1;
        },
        "click": function($event) {
          _vm.upHere = true;
          _vm.upIndex = index
        }
      }
    }, [_vm._v("\n                          " + _vm._s(slot.startAt) + "\n                          "), (_vm.upHere && index === _vm.upIndex) ? _c('span', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getDataForTerm(slot.startAt, slot.trainingType))
      }
    })]) : _vm._e()]), _vm._v(" "), (_vm.isVisibleAddUserToTerm) ? _c('td', {
      style: (_vm.getRowStyle(slot)),
      attrs: {
        "data-title": _vm.locale.t('label_reserve_training')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.openChooseUser(slot)
        }
      }
    }, [_c('i', {
      staticClass: "ti-plus"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_reserve")) + "\n                          ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      style: (_vm.getRowStyle(slot)),
      attrs: {
        "data-title": _vm.locale.t('label_edit')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editTraining(slot)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_edit")) + "\n                            ")])]), _vm._v(" "), _c('td', {
      style: (_vm.getRowStyle(slot)),
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteTraining(slot)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_delete")) + "\n                            ")])]), _vm._v(" "), _c('td', {
      style: (_vm.getRowStyle(slot)),
      attrs: {
        "data-title": _vm.locale.t('label_delete_and_cancel_all_users')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteTrainingAndUsers(slot)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_delete_and_cancel_all_users")) + "\n                          ")])]), _vm._v(" "), (!slot.deactivated) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_deactivate')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deactiveTraining(slot)
        }
      }
    }, [_c('i', {
      staticClass: "ti-close"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_deactivate")) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (slot.deactivated) ? _c('td', {
      style: (_vm.getRowStyle(slot)),
      attrs: {
        "data-title": _vm.locale.t('label_activate')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.activeTraining(slot)
        }
      }
    }, [_c('i', {
      staticClass: "ti-control-play"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_activate")) + "\n                            ")])]) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), _c('choose-user-modal', {
    attrs: {
      "show": _vm.chooseUser
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f75724a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trainings/View/ViewTrainings.vue
// module id = 730
// module chunks = 0